import classNames from 'classnames';
import { Link } from 'react-router';
import { dsClass } from '../../common/constants/dsClasses';
import { paths } from '../../common/constants/pathVariables';
import { instructionsForServiceMsg, instructionsMsg, seeMsg, t, technicalDataMsg } from '../../common/i18n';
import { TechnicalInformationBroadBand, TechnicalInformationMobile } from '../../common/utils/accordionUtils';
import { SubscriptionType } from '../../generated/api/subscriptionType';
import { DetailsWithCard } from '../DetailsWithInfoColumn/DetailsWithInfoColumn';
import type { Subscription } from '../../generated/api/subscription';

export interface BroadbandSubscriptionTechnicalDetailsProps {
  subscription: Subscription;
}

export const BroadbandSubscriptionTechnicalDetails = ({ subscription }: BroadbandSubscriptionTechnicalDetailsProps) => {
  return (
    <DetailsWithCard
      cardContent={
        <>
          <h3>{t.RD4R(instructionsMsg)}</h3>
          <p>
            {t.LJ10(seeMsg)}
            <Link to={paths.INSTRUCTIONS_FIXED_BROADBAND} target="_blank" rel="noopener noreferrer">
              {t.Z72R(instructionsMsg.toLowerCase())}
            </Link>
            {t.U63I(instructionsForServiceMsg)}
          </p>
        </>
      }
    >
      <h3 className={classNames(dsClass.H3_BOOK, dsClass.MARGIN_BOTTOM_6)}>{t.L2MX(technicalDataMsg)}</h3>
      {subscription.subscriptionType === SubscriptionType.MOBILE_BROADBAND ? (
        <TechnicalInformationMobile details={subscription.details?.mobile} />
      ) : (
        <TechnicalInformationBroadBand details={subscription.details?.broadband} />
      )}
    </DetailsWithCard>
  );
};
